import jquery = require('jquery')
import { Menu } from './menu';
class App {
  constructor() {
  }
}

$(() => {
  new Menu().init();
});